import {
  GET_PRODUCTS_REQUEST,
  GET_PRODUCTS_SUCCESS,
  GET_PRODUCTS_FAILURE,
} from "../../constants";
import { createAction, createErrorAction } from "../../utils";

const getProductsRequest = createAction(GET_PRODUCTS_REQUEST);
const getProductsSuccess = createAction(GET_PRODUCTS_SUCCESS);
const getProductsFailure = createErrorAction(GET_PRODUCTS_FAILURE);

// Settings
import supportedAddonProducts from "../../../lib/supportedAddonProducts";

// Helpers
import { getUpsellProductsAndAddonPrices } from "../getUpsellProductsAndAddonPrices/getUpsellProductsAndAddonPrices";

export const loadUpsellProducts = () => {
  return async (dispatch, getState, { api }) => {
    const state = getState();
    const { chosenPackage, cartItems } = state.cart;

    // Load request
    dispatch(getProductsRequest());

    // Object to hold all the responses we get in this action
    // upsellProducts and addonProducts are harcoded with
    // initial values if the backend fails to respond with data
    const responseData = {
      packages: false,
      packageCaps: {},
      upsellProducts: ["PPS_SMALL", "PPS_MEDIUM", "PPS_LARGE"],
      addonProducts: supportedAddonProducts,
      addonProductPrices: {},
      highlightedUpsell: null,
    };

    // TODO: Use the /rest/plans/{plan}/prices endpoint to get the prices for plans
    // That way both addon products and packages will have the same price object
    // shapes in the store.
    // When this is done <Price /> can be used everywhere to format prices based
    // on numbers.
    // First get the hostingpackages..
    try {
      const data = await api.getHostingPackages();
      responseData.packages = data;
      // Set the packages on the window object - Used by other apps
      window.packages = data;
    } catch (err) {
      console.error("Get hosting packages failed", err);
    }

    // Then get the feature caps
    try {
      const { features } = await api.getPackageCaps();
      responseData.packageCaps = features;
    } catch (err) {
      console.error("Get package features failed", err);
    }

    // If customer already choose a package, fetch the upsell suggestions (packages and addon products)
    // chosenPackage === DOMAIN_ONLY if there is only domain in the cart.
    if (chosenPackage) {
      const result = await dispatch(
        getUpsellProductsAndAddonPrices(chosenPackage, cartItems.length),
      );

      responseData.upsellProducts = result.upsellProducts;
      responseData.addonProductPrices = result.addonProductPrices;
      responseData.highlightedUpsell = result.highlightedUpsell;
    }

    if (responseData.packages) {
      dispatch(getProductsSuccess(responseData));
    } else {
      dispatch(getProductsFailure());
    }
  };
};
